import { normalizedUrl } from '../helpers/normalizedUrl';

export const getShopifyAuthUrl = (shop: string) => {
  return `${process.env.REACT_APP_GQL_ENDPOINT?.replace(/\/[^/]+$/, '')}/connect/shopify?shop=${normalizedUrl(
    shop,
  )}&action=install`;
};
